<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>坏账申请信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="坏账申请编号：">{{queryParams.badNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同编号：">
              <span class="approval" @click="onContract">{{queryParams.orderContractNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户合同编号：">{{queryParams.customerContractCode}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户名称：">
              <span class="approval" @click="onCusName">{{queryParams.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同金额：">{{queryParams.contractTotal|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已收账款：">{{queryParams.accountsReceived|priceFilterNum}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="应收账款：">{{queryParams.accountsCollect|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已到期应收账款：">{{queryParams.accountsDue|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未到期应收账款：">{{queryParams.accountsOutstanding|priceFilterNum}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>当前状态</span>
      </div>
    </div>
    <!-- 进度条 -->
    <div style="margin: 20px auto; width: 60%;">
      <el-steps :active="state" finish-status="finish">
        <el-step title="发起申请" icon="el-icon-success"></el-step>
        <el-step title="审核中" icon="el-icon-success"></el-step>
        <el-step v-if="queryParams.state !== 3" title="财务确认中" icon="el-icon-success"></el-step>
        <el-step v-if="queryParams.state !== 3" title="已确认" icon="el-icon-success"></el-step>
        <el-step v-else title="不通过" status="error"></el-step>
      </el-steps>
    </div>
    <div class="item-box-content">
      <el-form class="details-line-height" style="padding:0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请坏账金额：">{{queryParams.badCount|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请人：">{{queryParams.createUser}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">{{queryParams.createDate | dateFilter}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="申请原因：">{{queryParams.mark}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="queryParams.state===2 || queryParams.state===4">
          <el-col :span="8">
            <el-form-item label="公司承担：">{{queryParams.companyCommitment}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="提成结算：">{{queryParams.commissionDeduction}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="20" v-if="queryParams.state!==1">
            <el-form-item label="备注：">{{queryParams.exPlain}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品清单</span>
      </div>
      <!-----------------------                期货             ------------------------------>
      <div v-if="queryParams.orderShipmentStateVoList">
        <div v-for="item in queryParams.orderShipmentStateVoList" :key="item.id">
          <el-row style="margin:30px 0 20px">
            <el-col :span="8">{{item.shipName}}：{{ item.shipPrice|priceFilterNum }}</el-col>
            <el-col :span="8">本期货款：{{ item.shipTotal|priceFilterNum }}</el-col>
            <el-col :span="8">预计付款时间：{{ item.shipPayDate }}</el-col>
          </el-row>
          <el-table
            border
            :header-cell-style="tableHeader"
            :data="item.orderStockupSourseStateVoList"
          >
            <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
            <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
            <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="型号" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="approval line-limit-length"
                  @click="onProductDetail(scope.row)"
                >{{ scope.row.proType }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="数量"></el-table-column>
            <el-table-column prop="cbUnit" label="单位"></el-table-column>
            <el-table-column prop="cbExtimeValue" label="货期" width="65">
              <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
            </el-table-column>
            <el-table-column prop="cbPrice" label="销售单价">
              <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column prop="cbDiscount" label="折扣">
              <template slot-scope="scope">{{scope.row.cbDiscount|perCentFilter}}</template>
            </el-table-column>
            <el-table-column label="毛利率">
              <template slot-scope="scope">{{scope.row.cbRate|perCentFilter}}</template>
            </el-table-column>
            <el-table-column prop="cbUnitPrice" label="供货单价">
              <template slot-scope="scope">{{scope.row.cbUnitPrice|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column prop="cbFacePrice" label="面价">
              <template slot-scope="scope">{{scope.row.cbFacePrice|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="备货状态">
              <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
            </el-table-column>
            <el-table-column label="发货状态">
              <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
            </el-table-column>
            <el-table-column label="开票状态">
              <template
                slot-scope="scope"
              >{{scope.row.invoiceState===1?'已开票':scope.row.invoiceState===2?'开票审核':'未开票'}}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-----------------------                非期货             ------------------------------>
      <el-table
        v-else
        max-height="378"
        style="margin-top:20px"
        border
        :header-cell-style="tableHeader"
        :data="queryParams.orderContractContentStateVoList"
      >
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column label="货期" width="65">
          <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
        </el-table-column>
        <el-table-column prop="cbPrice" label="销售单价">
          <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column prop="cbDiscount" label="折扣">
          <template slot-scope="scope">{{scope.row.cbDiscount|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{scope.row.cbRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column prop="cbUnitPrice" label="供货单价">
          <template slot-scope="scope">{{scope.row.cbUnitPrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column prop="cbFacePrice" label="面价">
          <template slot-scope="scope">{{scope.row.cbFacePrice|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="备货状态">
          <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
        </el-table-column>
        <el-table-column label="发货状态">
          <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
        </el-table-column>
        <el-table-column label="开票状态">
          <template
            slot-scope="scope"
          >{{scope.row.invoiceState===1?'已开票':scope.row.invoiceState===2?'开票审核':'未开票'}}</template>
        </el-table-column>
      </el-table>
      <h4>总计</h4>
      <el-table border :header-cell-style="tableHeader" :data="listTotal">
        <el-table-column label="销售总额">
          <template slot-scope="scope">{{scope.row.totalQuotation|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="供货总额">
          <template slot-scope="scope">{{scope.row.actualPriceQuotation|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="面价总额">
          <template slot-scope="scope">{{scope.row.facePrice|priceFilterNum}}</template>
        </el-table-column>
      </el-table>
    </div>
    <!-------------- 工单日志 -------------->
    <operation-log-and-flow flowLabel="坏账流程" typesel="financeBadDebt" :id="id"></operation-log-and-flow>
  </div>
</template>
<script>
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import { queryFinanceBadDebtByFbdId } from '@/api/sell/sellManage'
export default {
  components: { 'operation-log-and-flow': operationLogAndFlow },
  data() {
    return {
      id: '',
      listTotal: [], // 总计列表
      queryParams: {},
      state: 1
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.prodId } })
    },
    onContract() {
      this.$router.push({
        name: 'contractEdit',
        query: {
          id: this.queryParams.obId,
          cusId: this.queryParams.cusId
        }
      })
    },
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: {
          id: this.queryParams.cusId
        }
      })
    },
    init() {
      queryFinanceBadDebtByFbdId(this.$route.query.fbcId).then((res) => {
        if (res.data.code === 200) {
          this.queryParams = JSON.parse(JSON.stringify(res.data.obj))
          this.id = res.data.obj.id
          const obj = {
            totalQuotation: res.data.obj.totalQuotation,
            actualPriceQuotation: res.data.obj.actualPriceQuotation,
            facePrice: res.data.obj.facePrice
          }
          this.listTotal.push(obj)
          this.state =
            res.data.obj.state === 2
              ? 4
              : res.data.obj.state === 4
                ? 3
                : res.data.obj.state === 3
                  ? 3
                  : 2
        }
      })
    },
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
